import { render, staticRenderFns } from "./ReportMergeView.vue?vue&type=template&id=56076eb0&scoped=true"
import script from "./ReportMergeView.vue?vue&type=script&lang=js"
export * from "./ReportMergeView.vue?vue&type=script&lang=js"
import style0 from "./ReportMergeView.vue?vue&type=style&index=0&id=56076eb0&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56076eb0",
  null
  
)

export default component.exports